import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const SupportSubtitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['bold']};
  font-size: ${42 * Screen.widthRatio}px;
  margin-bottom: ${20 * Screen.widthRatio}px;
`;

export default SupportSubtitle;
